// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#magicform-bubble-widget-chat-panel-minimal {
  margin-bottom: 1.25rem;
  border-radius: 1rem;
  /* width: min(100vw, 360px); */
  /* box-shadow: 0 5px 10px rgb(0 0 0 / .3); */
  /* background-color: white; */
  flex-direction: column;
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Widget/BubbleWidget.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;AACtB","sourcesContent":["#magicform-bubble-widget-chat-panel-minimal {\n  margin-bottom: 1.25rem;\n  border-radius: 1rem;\n  /* width: min(100vw, 360px); */\n  /* box-shadow: 0 5px 10px rgb(0 0 0 / .3); */\n  /* background-color: white; */\n  flex-direction: column;\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
